import { ExporterDataInput } from '@gtpl/shared-models/logistics';
import { FactoriesInput, PlantInvoiceDetailsModel, PlantInvoiceDetailsRequest } from '@gtpl/shared-models/sale-management';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { Button, Card } from 'antd';
import { componentRequest } from 'libs/shared-models/logistics/src/lib/container-register/container-soId.request';
import moment from 'moment';
import React, { useEffect, useState } from 'react'

export interface SpsaExportInvoiceProps {
  saleOrderId: number;
}

const SpsaExportInvoice = (props: SpsaExportInvoiceProps) => {
    const salOrderService = new SaleOrderService();
    const [plantDetails, setPlantDetails] = useState<PlantInvoiceDetailsModel>();
    
    let exporterDetails = ExporterDataInput;
    const idToFind = plantDetails?.isInvoiced === "YES" ? plantDetails?.exporterId : plantDetails?.unitId;
    const exporterData = exporterDetails.find(item => item.value === idToFind);
    const processingId= plantDetails?.processingUnit;
    const processingData = exporterDetails.find((item) => item.value === processingId)

    let exporterPlant = FactoriesInput;
    const exportersPlant = exporterPlant.find((item) => item.id == processingId )
     const isIndia = plantDetails?.country?.toLowerCase() === "india";

      useEffect(() => {
        if (props.saleOrderId) {
          getData(props.saleOrderId);
        }
      }, [props.saleOrderId]);

      const getData = (saleOrderId) => {
        salOrderService
          .getPlantInvoiceDetails(new PlantInvoiceDetailsRequest(saleOrderId))
          .then((res) => {
            if (res.status) {
              setPlantDetails(res.data);
              res.data.gradeInfo.map((res) =>
                res.info.filter((val) => val.itemCode != null)
              );
            } else {
              if (res.intlCode) {
                setPlantDetails(undefined);
                AlertMessages.getErrorMessage(res.internalMessage);
              } else {
                AlertMessages.getErrorMessage(res.internalMessage);
              }
            }
          })
          .catch((err) => {
            AlertMessages.getErrorMessage(err.message);
            setPlantDetails(undefined);
          });
      };

      const exchangeRate = Number(plantDetails?.exchangeRate || 1);

const currencySymbol = isIndia ? "₹" : "$";

const currencyName = isIndia
  ? "RUPEES"
  : plantDetails?.saleOrderItems?.[0]?.currencyDetails || "USD";

      const allItems = plantDetails?.gradeInfo?.reduce((acc, g) => acc?.concat(g.info), []) || [];

let totalQty = 0;
let totalAmount = 0;

const convertedItems = allItems.map((item) => {

  let quantityInKgs = 0;

  // QUANTITY ALWAYS IN KGS
  if (
    item?.uomId === 2 || // LB
    item?.uomId === 3    // OZ
  ) {
    quantityInKgs = Number(item.netWeight || item.quatity || 0) * 0.454;
  } else {
    quantityInKgs = Number(item.netWeight || item.quatity || 0);
  }

  // RATE
  let rate = Number(item.price || 0);

  // INDIA => INR
  // EXPORT => USD/FOREIGN
  let amount = 0;

  if (isIndia) {
    amount = quantityInKgs * rate * exchangeRate;
  } else {
    amount = quantityInKgs * rate;
  }

  totalQty += quantityInKgs;
  totalAmount += amount;

  return {
    ...item,
    quantityInKgs,
    rate,
    amount,
  };
});

let sgstPer = 0;
let cgstPer = 0;
let igstPer = 0;

plantDetails?.saleOrderItems?.forEach((item: any) => {

  const taxPer = Number(item?.taxPer || 0);

  const taxCategory =
    item?.taxCategory?.toLowerCase() || '';

  const taxName =
    item?.taxName?.toLowerCase() || '';

  // STATE TAX
  if (taxCategory === 'state') {

    if (
      taxName.includes('cgst') ||
      taxName.includes('sgst')
    ) {

      sgstPer = taxPer / 2;
      cgstPer = taxPer / 2;
    }
  }

  // CENTRAL TAX
  else if (taxCategory === 'central') {

    if (taxName.includes('igst')) {

      igstPer = taxPer;
    }
  }
});

const sgstAmount = isIndia
  ? (totalAmount * sgstPer) / 100
  : 0;

const cgstAmount = isIndia
  ? (totalAmount * cgstPer) / 100
  : 0;

const igstAmount = !isIndia
  ? (totalAmount * igstPer) / 100
  : 0;

const grandTotalIndia =
  totalAmount + sgstAmount + cgstAmount;

const grandTotalExport =
  totalAmount;

const finalGrandTotal = isIndia
  ? grandTotalIndia
  : grandTotalExport;

  const amountInWords = (amount: number) => {

  const words = require('number-to-words');

  const value = Math.floor(amount);

  return `${words.toWords(value).toUpperCase()} ${currencyName} ONLY`;
};
let serialNo = 1;

  const getCssFromComponent = (fromDoc: Document, toDoc: Document) => {
    Array.from(fromDoc.styleSheets).forEach((styleSheet: CSSStyleSheet) => {
      try {
        if (styleSheet?.cssRules) { // true for inline styles and same-origin stylesheets
          const newStyleElement = toDoc.createElement("style");
          Array.from(styleSheet.cssRules).forEach((cssRule: CSSRule) => {
            newStyleElement.appendChild(toDoc.createTextNode(cssRule.cssText));
          });
          toDoc.head.appendChild(newStyleElement);
        }
      } catch (e) {
        console.warn("Could not access stylesheet rules for", styleSheet.href, e);
      }
    });
  };

  const printOrder = () => {
    const divContents = document.getElementById('printme').innerHTML;
    const element = window.open('', '', 'height=700, width=1024');
    element.document.write(divContents);
    getCssFromComponent(document, element.document);
    element.document.close();
    setTimeout(() => {
      element.print();
      element.close(); // to close window when click on cancel/Save
// model should be open
    }, 1000);
  };
  return (
    <div>
        <Card  title="EXPORT INVOICE"
                style={{ textAlign: 'center' }}
                headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
                extra={
                  <span style={{ color: 'white' }}>
                    <Button onClick={printOrder} className="panel_button">
                      Print
                    </Button>
                  </span>
                }>
            <div id="printme">
                <html>
                    <body >
                        <table style={{width:'100%',border:'1px solid black',borderCollapse:'collapse'}}>
                            <tr>
                                <td style={{border:'1px solid black',padding:'5px',textAlign:"center"}} colSpan={7}><b>INVOICE</b></td>
                            </tr>
                            <tr>
                                <th style={{border:'1px solid black',padding:'5px',textAlign:"left"}} colSpan={isIndia?2:4} rowSpan={2}>                                   
                                <div>EXPORTER</div>
                                <div>{exporterData?.name}</div>
                                <div>{exporterData?.addressOne}</div>
                                <div>{exporterData?.addressTwo}</div>
                                <div>{exporterData?.state} - {exporterData?.postalCode}</div>
                                <div>{exporterData?.country}</div>
                                <div>PH: {exporterData?.phoneNumber}</div>
                                </th>
                                {isIndia ? 
                                <>
                                <th style={{border:'1px solid black',padding:'5px',textAlign:"left"}} colSpan={2}>DATE:{plantDetails?.invoiceDate}</th>
                                <th style={{border:'1px solid black',padding:'5px',textAlign:"left"}} colSpan={3}>INVOICE No:{plantDetails?.invoiceNumber}</th>
                                </>
                                 :<>
                                 <th style={{border:'1px solid black',padding:'5px',textAlign:"left"}} colSpan={3}>
                                    <div style={{display:'flex',flexDirection:'column'}}>
                                        <span>INVOICE NO & DATE</span>
                                    </div>
                                    <div style={{display:'flex',flexDirection:'column'}}>
                                        <span>{plantDetails?.invoiceNumber} DATED {plantDetails?.invoiceDate}</span>
                                    </div>
                                </th>
                                 </>}
                            </tr>
                            <tr>
                                {isIndia ? 
                                <>
                                <th style={{border:'1px solid black',padding:'5px',textAlign:"left"}} colSpan={2}>E WAY BILL NO</th>
                                <th style={{border:'1px solid black',padding:'5px',textAlign:"left"}} colSpan={3}>
                                    <div style={{display:'flex',flexDirection:'column'}}>
                                        <span>D/C No:</span>
                                        <span style={{fontSize:'10px'}}>{plantDetails?.dcNo}</span>
                                    </div>
                                    <div style={{display:'flex',flexDirection:'column'}}>
                                        <span>D/C Date:</span>
                                        <span style={{fontSize:'10px'}}>{moment(plantDetails?.dcDate)?.format('DD-MM-YYYY')}</span>
                                    </div>
                                </th>
                                </>
                                 :<>
                                 <th style={{border:'1px solid black',padding:'5px',textAlign:"left"}} colSpan={3}> SALES CONTRACT :{plantDetails?.poNumber} DATED {plantDetails?.poDate} </th>
                                 </>}
                            </tr>

                            <tr>
                                <th style={{border:'1px solid black',padding:'5px',textAlign:"left"}} colSpan={isIndia?2:4} rowSpan={2}>
                                  <div><b>CONSIGNEE:</b></div> 
                                  <div>{plantDetails?.consignee}</div>
                                  <div>{plantDetails?.consigneeAddress}</div>
                                  <div>GSTIN: </div>
                                </th> 
                                {isIndia ?<>
                                <th style={{border:'1px solid black',padding:'5px',textAlign:"left"}} colSpan={5}>DELIVERY ADDRESS:{plantDetails?.saleOrderItems[0]?.deliveryaddress}</th>
                                 </>:<>
                                <th style={{border:'1px solid black',padding:'5px',textAlign:"left"}} colSpan={3}>OTHER REFERENCE:{plantDetails?.remarks}</th>
                                 </>}
                            </tr>
                            <tr>
                                <th style={{border:'1px solid black',padding:'5px',textAlign:"left"}} colSpan={isIndia?5:3}>
                                    <div>&nbsp;</div>
                                    <div>&nbsp;</div>
                                    <div>&nbsp;</div>
                                    <div>&nbsp;</div>
                                </th>
                            </tr>

                            {isIndia ?<>
                            <tr>
                                <th style={{border:'1px solid black',padding:'5px',textAlign:"left"}} >
                                    <div><b>DISPATCH THROUGH:{plantDetails?.flightNumber}</b></div>
                                    <div></div>
                                </th>
                                 <th style={{border:'1px solid black',padding:'5px',textAlign:"left"}} >
                                    <div><b>DESTINATION:</b></div>
                                    <div>{plantDetails?.destinationName}</div>
                                </th>
                                <th style={{border:'1px solid black',padding:'5px',textAlign:"left"}} colSpan={5}></th>
                            </tr>
                            </>:<>
                             <tr>
                                <td style={{border:'1px solid black',padding:'5px',textAlign:"left"}} colSpan={2}>
                                    <div><b>PRE CARRIAGE BY :</b></div>
                                    <div>{plantDetails?.preCarriageBy}</div>
                                    </td>
                                  <td style={{border:'1px solid black',padding:'5px',textAlign:"left"}} colSpan={2}>
                                    <div><b>PLACE OF RECEIPT BY PRE CARRIAGER:</b></div>
                                    <div>{plantDetails?.placeOfReceipt}</div>
                                    </td>
                                  <td style={{border:'1px solid black',padding:'5px',textAlign:"left"}} >
                                    <div><b>COUNTRY OF ORIGIN OF GOODS:</b></div>
                                    <div>INDIA</div>
                                    </td>
                                   <td style={{border:'1px solid black',padding:'5px',textAlign:"left"}} colSpan={2}>
                                    <div><b>DESTINATION COUNTRY:</b></div>
                                    <div>{plantDetails?.destinationName}</div>
                                    </td>       
                             </tr>
                             <tr>
                                 <td style={{border:'1px solid black',padding:'5px',textAlign:"left"}} colSpan={2}>
                                    <div><b>VESSEL/FLIGHT NO :</b></div>
                                    <div>{plantDetails?.vesselNumber}</div>
                                    </td>
                                  <td style={{border:'1px solid black',padding:'5px',textAlign:"left"}} colSpan={2}>
                                    <div><b>PORT OF LOADING:</b></div>
                                    <div>{plantDetails?.portofloading}</div>
                                    </td>
                                  <td style={{border:'1px solid black',padding:'5px',textAlign:"left"}} colSpan={3} rowSpan={2}>
                                    <div><b>TERMS OF DELIVERY & PAYMENT:</b></div>
                                    <div>{plantDetails?.deliveryTerms}</div>
                                    </td>
                             </tr>
                             <tr>
                                <td style={{border:'1px solid black',padding:'5px',textAlign:"left"}} colSpan={2}>
                                    <div><b>PORT OF DISCHARGE :</b></div>
                                    <div>{plantDetails?.portOfDischarge}</div>
                                    </td>
                                  <td style={{border:'1px solid black',padding:'5px',textAlign:"left"}} colSpan={2}>
                                    <div><b>FINAL DESTINATION:</b></div>
                                    <div>{plantDetails?.destinationName}</div>
                                    </td>
                             </tr>
                            </>}
                            
                            <tr>
                            <th style={{border:'1px solid black',padding:'5px'}} >SI NO</th>
                            {!isIndia && <th style={{border:'1px solid black',padding:'5px'}} >MARKS & NOS</th>}
                            {!isIndia && <th style={{border:'1px solid black',padding:'5px'}} >KIND OF PACKAGES</th>}
                            <th style={{border:'1px solid black',padding:'5px'}}  >DESCRIPTION OF GOODS</th>
                            {isIndia && (
                            <>
                            <th style={{border:'1px solid black',padding:'5px'}} >HSN/SAC</th>
                            <th style={{border:'1px solid black',padding:'5px'}} >NOS(BALES/BAGS/CARTONS)</th>
                            </>
                            )}
                            <th style={{border:'1px solid black',padding:'5px'}} >QUANTITY(KGS)</th>
                            <th style={{border:'1px solid black',padding:'5px'}} >RATE</th>
                            <th style={{border:'1px solid black',padding:'5px'}} >AMOUNT</th>
                            </tr> 
{plantDetails?.gradeInfo.map((grade, index) => {

    const productDescription = grade.productDescription;

    return grade.info.map((item, subIndex) => {

        const convertedItem = convertedItems.find(
            (c) => c.saleOrderItemId === item.saleOrderItemId
        );

        return (
            <tr key={`${index}-${subIndex}`}>

                <td style={{border:'1px solid black',padding:'5px'}}>
                    {serialNo++}
                </td>

                {!isIndia && index === 0 && subIndex === 0 && (
    <td
        rowSpan={
            plantDetails?.gradeInfo.reduce(
                (acc, grade) => acc + grade.info.length,
                0
            )
        }
        style={{
            border: '1px solid black',
            padding: '5px',
            textAlign: 'center',
            verticalAlign: 'bottom'
        }}
    >
        <div>{plantDetails?.marksAndNo || '-'}</div>
    </td>
)}

                {!isIndia && (
                    <td style={{border:'1px solid black',padding:'5px'}}>
                      <div>{item.PackageType || '-'}</div>
                        <div>{item.noOfCases}</div>
                    </td>
                )}

                <td style={{border:'1px solid black',padding:'5px'}}>
                    {productDescription || item.gradeNames}
                </td>

                {isIndia && (
                    <td style={{border:'1px solid black',padding:'5px'}}>
                        {item.hsnCode || '-'}
                    </td>
                )}

                {isIndia && (
                    <td style={{border:'1px solid black',padding:'5px'}}>
                        {item.noOfCases}
                    </td>
                )}

                <td style={{border:'1px solid black',padding:'5px'}}>
                    {Number(convertedItem?.quantityInKgs || 0).toFixed(3)}
                </td>

                <td style={{border:'1px solid black',padding:'5px'}}>
                    {Number(convertedItem?.rate || 0).toFixed(2)}
                </td>

                <td style={{border:'1px solid black',padding:'5px'}}>
                    {Number(convertedItem?.amount || 0).toFixed(2)}
                </td>

            </tr>
        );
    });
})}

                            {isIndia?<>
                            <tr>
                             <td style={{border:'1px solid black',padding:'5px'}} colSpan={2}><b></b></td>   
                            <td style={{border:'1px solid black',padding:'5px'}} colSpan={2}><b>TOTAL QUANTITY IN KGS</b></td>
                            <td style={{border:'1px solid black',padding:'5px'}}>{totalQty.toFixed(3)}</td>
                            <td style={{border:'1px solid black',padding:'5px'}}><b>TOTAL</b></td>
                            <td style={{border:'1px solid black',padding:'5px'}}>{currencySymbol}{totalAmount.toFixed(2)}</td>
                            </tr>
                            <tr>
                               <td style={{border:'1px solid black',padding:'5px'}} colSpan={4} rowSpan={3}></td> 
                               <td style={{border:'1px solid black',padding:'5px'}}><b>SGST</b></td>
                               <td style={{border:'1px solid black',padding:'5px'}}>{sgstPer}%</td>
                               <td style={{border:'1px solid black',padding:'5px'}}> {sgstAmount.toFixed(2)}</td>
                            </tr>
                            <tr>
                               <td style={{border:'1px solid black',padding:'5px'}}><b>CGST</b></td>
                               <td style={{border:'1px solid black',padding:'5px'}}>{cgstPer}%</td>
                               <td style={{border:'1px solid black',padding:'5px'}}> {cgstAmount.toFixed(2)}</td>
                            </tr>
                            <tr>
                               <td style={{border:'1px solid black',padding:'5px'}}><b>IGST</b></td>
                               <td style={{border:'1px solid black',padding:'5px'}}>{igstPer}%</td>
                               <td style={{border:'1px solid black',padding:'5px'}}>{igstAmount.toFixed(2)}</td>
                            </tr>
                            </>:<></>}  

                            <tr>
                                <td style={{border:'1px solid black',padding:'5px'}} colSpan={4}>
                                    <div><b>AMOUNT CHARGABLE IN WORDS:</b> {amountInWords(finalGrandTotal)}</div>
                                </td>
                                <td style={{border:'1px solid black',padding:'5px'}} colSpan={2}><b>TOTAL</b></td>
                                <td style={{border:'1px solid black',padding:'5px'}} >{currencySymbol}
{finalGrandTotal.toFixed(2)}</td>
                            </tr> 

                            <tr>
                                <td colSpan={4} style={{padding:'5px'}}>
                                    {isIndia ?
                                    <>
                                    <div><b>BANK DETAILS:</b></div>
                                    <div>{exporterData?.name}</div>
                                    <div>{plantDetails?.bankInfo[0]?.bankName}, {plantDetails?.bankInfo[0]?.branchName}</div>
                                    <div>A/C No: {plantDetails?.bankInfo[0]?.bankAcc}</div>
                                    <div>IFSC Code: {plantDetails?.bankInfo[0]?.ifscCode}</div>
                                    <div>GSTIN: {exporterData?.GSTNumber}</div>
                                    </>
                                    :
                                    <>
                                    <div><b>IEC: {exporterData?.ieCode}</b></div>
                                    <div><b>GSTIN: {exporterData?.GSTNumber}</b></div>
                                    </>
                                    }
                                </td>
                                <td colSpan={3} style={{borderBottom:"1px solid black"}}></td>
                            </tr>

                            <tr>
                                <td colSpan={4} style={{borderRight:'1px solid black',padding:'5px'}}>
                                    <div><u><b>DECLARATION</b></u></div>
                                    <div>We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct.</div>
                                </td>
                                <td colSpan={3} style={{border:'1px solid black',padding:'5px'}}>
                                    <div><b>FOR {exporterData?.company}</b></div>
                                    <div>&nbsp;</div>
                                    <div>&nbsp;</div>
                                    <div>&nbsp;</div>
                                    <div style={{marginTop:'50px'}}>AUTHORISED SIGNATORY</div>
                                </td>
                            </tr>
                        </table>        
                    </body>
                </html>
            </div>
        </Card>
    </div>
  )
}

export default SpsaExportInvoice